import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Card } from '../../../components/Card';
import { Dropdown } from '../../../components/Dropdown';
import { fetchStatsFor } from '../actions';
import { StatsResult } from './stats';
import { InspectionStatsPage } from './inspections';

const STATE = {
  selected: null,
};
/* eslint-disable react/prefer-stateless-function */
class StatsPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  tagChange(option) {
    this.setState({ selected: option });
    this.props.get(option.value);
  }

  render() {
    return (
      <Switch>
        <Route path="(.*)/statistics/inspections" component={InspectionStatsPage} />
        <Route
          render={() => (
            <div>
              <Card headerTitle={this.lbl('stats.filter')}>
                <Dropdown
                  small
                  options={this.props.tags.map(tag => ({
                    label: tag.name,
                    value: tag.id,
                  }))}
                  value={this.state.selected}
                  onChange={this.tagChange.bind(this)}
                />
              </Card>

              {this.state.selected && this.state.selected.value ? <StatsResult tag_id={this.state.selected.value} /> : ''}
            </div>
          )}
        />
      </Switch>
    );
  }
}

StatsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get(tag_id, filter) {
      dispatch(fetchStatsFor(tag_id, filter));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const StatsPage = compose(
  withConnect,
  withRouter,
)(StatsPageComp);
